import React from "react";
import { Row, Col } from "reactstrap";
import "./OrderListComponent.scss";
import TextField from "../../../common/TextField/TextField";
import {
  IOrderListComponentProps,
  IOrderAddUpdateList,
} from "../../../../interfaces/Index";
import { clickToFocus, formatToCurrency } from "../../../../utils/lib";

// This list contains the all the possible third scheduled sales tax IDs.
// This list will need to be updated when a new tax ID is added.
export const localThirdScheduledSalesTaxIds = ["1228", "1237", "1221"];

export const calculateTotal = (list: Array<IOrderAddUpdateList>) => {
  let listTotal = 0;
  list.map((item) => (listTotal += calculateCutPrice(item) * item.quantity));
  return formatToCurrency(listTotal);
};

export const calculateCutPrice = (item: IOrderAddUpdateList) => {
  const totalDiscount =
    Number(item.discount) + Number(item.additionalDiscount as number);
  return (item.productOriginalPrice as number) - totalDiscount;
};

// export const checkForMRPZero = (item: IOrderAddUpdateList) =>
//   localThirdScheduledSalesTaxIds.includes(
//     item.salesTaxId ? item.salesTaxId : ""
//   );

const OrderListComponent: React.FunctionComponent<IOrderListComponentProps> = (
  props
) => {
  const handleChangeValidateForm = (e: any, index: number) => {
    const enteredQty = e.target.value;
    const alreadyBookedQty = props.orderList[index].originalQuantity || 0;
    const availableQty =
      props.unitsAvailable[index] || props.orderList[index].stock;

    if (enteredQty < 1 || enteredQty > alreadyBookedQty + availableQty) {
      props.handleStockValidationCheck({ validateForm: "disabled" });
    } else {
      props.handleStockValidationCheck({ validateForm: "enabled" });
    }
    props.handleChange(e, index);
  };

  const orderList = () =>
    props.orderList.map((item, index) => (
      <section className="list-row" key={index}>
        <div className="order-list-col">
          {item.itemName}
          <div
            className={
              !props.orderStatus &&
              localThirdScheduledSalesTaxIds.includes(
                item.salesTaxId ? item.salesTaxId : ""
              )
                ? "remove-item-right"
                : "remove-item"
            }
            id={`remove-${index}`}
            onClick={(e: any) => props.handleChange(e, index)}
          >
            Remove
          </div>
          {/* To be decided which price to show. */}
          {!props.orderStatus &&
            localThirdScheduledSalesTaxIds.includes(
              item.salesTaxId ? item.salesTaxId : ""
            ) && (
              <div
                className={
                  item.retailPrice && item.retailPrice > 0 ?  "" : ` mrp-zero` 
                }
              >
                (MRP: {item.retailPrice})
              </div>
            )}
        </div>
        <div
          className="order-list-col order-discount-trigger"
          onClick={() => props.showDiscountModal?.(true, index)}
        >
          {(item.discount > 0 ||
            (item.additionalDiscount as number) > 0 ||
            (item.itemPrice > 0 &&
              (item.productOriginalPrice as number) - item.itemPrice > 0)) && (
            <div className="discount-price">
              Rs. {formatToCurrency(item.productOriginalPrice as number)}
            </div>
          )}
          {item.discount > 0 ||
          (item.productOriginalPrice as number) - item.itemPrice > 0 ||
          (item.additionalDiscount as number) > 0
            ? `Rs. ${formatToCurrency(calculateCutPrice(item))}`
            : `Rs. ${formatToCurrency(item.productOriginalPrice as number)}`}
        </div>
        <div className="order-list-col text-center">
          <Row>
            <Col lg="5">x</Col>
            <Col lg="7" className="quantity-container">
              {index === 0 ? (
                <TextField
                  id={`quantity-${index}`}
                  label=""
                  placeholder="Qty"
                  handleChange={(e: any) => handleChangeValidateForm(e, index)}
                  value={item.quantity}
                  onFocus={clickToFocus}
                  autoFocus={true}
                  className={
                    props.unitsAvailable &&
                    item.quantity >
                      props.orderList[index].originalQuantity +
                        props.unitsAvailable[index]
                      ? "warning-textfield"
                      : ""
                  }
                />
              ) : (
                <TextField
                  id={`quantity-${index}`}
                  label=""
                  placeholder="Qty"
                  handleChange={(e: any) => handleChangeValidateForm(e, index)}
                  value={item.quantity}
                  onFocus={clickToFocus}
                  className={
                    props.unitsAvailable &&
                    item.quantity >
                      props.orderList[index].originalQuantity +
                        props.unitsAvailable[index]
                      ? "warning-textfield"
                      : ""
                  }
                />
              )}
            </Col>
            {/* {JSON.stringify(props.unitsAvailable)} */}
          </Row>
          {props.unitsAvailable &&
            item.quantity >
              props.orderList[index].originalQuantity +
                props.unitsAvailable[index] && (
              <Row className="warning-text text-center">
                {props.unitsAvailable[index]} units available
              </Row>
            )}
          {item.quantity > item.stock && (
            <Row className="warning-text text-center">
              {item.stock} units available
            </Row>
          )}
        </div>
        <div className="text-right order-list-col">
          Rs. {formatToCurrency(calculateCutPrice(item) * item.quantity)}
        </div>
      </section>
    ));

  return (
    <section className="order-list-container">
      <section className="order-list">{orderList()}</section>
      <div className="list-seperator"></div>
      <div className="clearfix"></div>
      <Row>
        <Col lg="6" className="total-items">
          {props.orderList.length} items
        </Col>
        <Col lg="6" className="text-right total-amount">
          Rs. {calculateTotal(props.orderList)}
        </Col>
      </Row>
    </section>
  );
};

export default OrderListComponent;
